<div class="flex justify-end border-b border-brand-100 bg-white px-5 py-3 lg:px-8">
  <nav class="inline-flex max-w-full gap-1 overflow-x-auto rounded-2xl border border-brand-100 bg-brand-50/50 p-1.5">
    @for (item of items; track item.route) {
      <a
        [routerLink]="item.route"
        routerLinkActive
        #rla="routerLinkActive"
        class="group inline-flex shrink-0 items-center gap-1.5 rounded-xl px-3 py-2 font-ui text-theme-xs font-bold transition"
        [class]="
          rla.isActive
            ? 'bg-white text-brand-700 shadow-theme-sm'
            : 'text-gray-500 hover:text-gray-700'
        "
      >
        <span class="h-4 w-4 shrink-0"><app-icon [name]="item.icon" /></span>
        <span class="whitespace-nowrap">{{ item.label }}</span>
        @if (item.badge && alertCount() > 0) {
          <span
            class="min-w-[20px] rounded-full px-1.5 py-0.5 text-center font-heading text-[11px] font-extrabold"
            [class]="rla.isActive ? 'bg-brand-500 text-white' : 'bg-gray-200 text-gray-600'"
          >
            {{ alertCount() }}
          </span>
        }
      </a>
    }
  </nav>
</div>
